// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';

class Toggle {
  constructor(config) {
    const { el } = config;

    // Set module dom elements
    this.trigger = el;

    if (!this.trigger.dataset.targets) return;

    this.targets = this.trigger.dataset.targets.split(',').map((selector) => document.querySelector(selector));
    this.toggleClass = this.trigger.dataset.toggleClass;
  }

  // Initialisation Function
  init = () => {
    if (this.trigger && this.toggleClass) {
      this.trigger.addEventListener('click', this.handleClick);
    }
  };

  handleClick = (e) => {
    e.preventDefault();

    this.targets.forEach((target) => {
      target.classList.toggle(this.toggleClass);
    });
  };
}

export default (settings) => initialiser(settings, Toggle);
